import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const schema = z
  .object({
    diffs: z.array(z.tuple([z.string().nullable(), z.string().nullable()])),
  })
  .refine(({ diffs }) =>
    diffs.every(([left, right]) => left !== null && right !== null),
  )
export type InputValues = z.infer<typeof schema>
export const resolver = zodResolver(schema)
